export default __webpack_public_path__ + "static/media/p3-12.dbfdb15c.png";